// DateRangePicker.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled  } from '@mui/material/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { AppStyle, AppWord } from '../value/AppConst';
import ValueMisc from '../value/ValueMisc';

const RangeContainer = styled(Box)({
    display: 'flex', alignItems: 'center',
});

const LabelBox = styled(Box)({marginRight:15, fontSize:'0.8rem', color: AppStyle.PrimaryRGB});

export default function DateRangePicker({
    dateFrom, dateTo, // Date
    onChangeFrom, onChangeTo,
    label, // if null, don't show label
}) {
    const [from, setFrom] = useState(dayjs(new Date()));
    const [till, setTill] = useState(dayjs(new Date()));
    
    useEffect(()=>{
        if(dateFrom) {
            setFrom(dayjs(dateFrom));
        }
        else setFrom(dayjs(new Date()));
    }, [dateFrom]);

    useEffect(()=>{
        if(dateTo) {
            setTill(dayjs(dateTo));
        }
        else setTill(dayjs(new Date()));
    }, [dateTo]);


    const onChangeDateFrom = (v) => {
        // return in yyyy-MM-dd format
        onChangeFrom(ValueMisc.getYMD(v.toDate()));
    };

    const onChangeDateTill = (v) => {
        // return in yyyy-MM-dd format
        onChangeTo(ValueMisc.getYMD(v.toDate()));
    };


    return(
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <RangeContainer>
                {
                    label && <LabelBox>{label}</LabelBox>
                }
                <DatePicker
                    sx={{width:150}}
                    slotProps={{
                        openPickerIcon:{fontSize:AppWord.SMALL},
                        textField:{size:AppWord.SMALL}
                    }}
                    format='YYYY-MM-DD'
                    value={from || ''}
                    onChange={onChangeDateFrom} />
                <span>&nbsp;~&nbsp;</span>
                <DatePicker
                    sx={{width:150}}
                    slotProps={{
                        openPickerIcon:{fontSize:AppWord.SMALL},
                        textField:{size:AppWord.SMALL}
                    }}
                    format='YYYY-MM-DD'
                    value={till || ''}
                    onChange={onChangeDateTill} />
            </RangeContainer>
        </LocalizationProvider>
    );
}

